<template>
  <div class="field" v-show="visible" :class="{condensed: isCondensed}">
    <div class="field-selection-wrapper range-selection-wrapper" :class="{condensed: isCondensed}">
      <question-attributes :colors="colors" :field="field"></question-attributes>
      <div class="field-selection-container range-selection-container" :class="rangeClasses">
        <div class="before-icon" v-if="rangeType == 'likert'">
          <img src="https://static-resources-guestflip.s3.eu-central-1.amazonaws.com/sad.png" alt="Sad"/>
          <span class="field-tooltip">Not likely</span>
        </div>
        <div
          v-if="!field.required"
          class="range-selection"
          @mouseover="hoverIndex = null"
          @mouseout="hover = -1"
          :key="field.id + '_' + -1"
          :class="{selected: field.isNull}"
          :style="null == hoverIndex ? hoverStyle : {}"
        >
          <div class="option" :style="field.isNull ? slotStyle : {}" @click="setStatus(field, null)">N/A</div>
        </div>
        <div
          class="range-selection"
          v-for="(option, idx) in field.answerOptions"
          v-show="!outOfFiveField || outOfFiveField && option.value % 2 == 0"
          @mouseover="hoverIndex = idx"
          @mouseout="hover = -1"
          :key="field.id + '_' + idx"
          :class="{selected: option.selected}"
          :style="idx == hoverIndex ? hoverStyle : {}"
        >
          <div v-if="alternativeStyle" class="option icon-option-container" :style="option.selected ? slotStyle : {}" @click="setStatus(option, idx)">
              <img class="icon-option" :src="`https://static-resources-guestflip.s3.eu-central-1.amazonaws.com/smileys/${option.value / 2}-star.png`">
          </div>
          <div v-else class="option" :style="option.selected ? slotStyle : {}" @click="setStatus(option, idx)">
            {{ outOfFiveField ? option.value / 2 : option.value }}
          </div>
        </div>
        <div class="after-icon" v-if="rangeType == 'likert'">
          <img src="https://static-resources-guestflip.s3.eu-central-1.amazonaws.com/happy.png" alt="Happy"/>
          <span class="field-tooltip">Very likely</span>
        </div>
      </div>
      <div class="error" v-if="field.invalid && !totalSelected">This field is required</div>
    </div>
  </div>
</template>

<script>
    import RadioField from './RadioField'
    export default {
        name: 'RadioField',
        extends: RadioField,
        props: ['field', 'colors', 'outOfFive'],
        data() {
            return {
                hoverIndex: -1,
                rangeType: 'likert'
            }
        },
        methods: {},
        computed: {
            outOfFiveField() {
              return this.outOfFive && !this.field.isNps;
            },
            isCondensed() {
              return this.field.condensed
            },
            slotStyle() {
                return {
                    backgroundColor: this.colors.highlightColor
                }
            },
            hoverStyle() {
                return {
                    borderColor: this.colors.highlightColor
                }
            },
            alternativeStyle() {
              return this.field.alternativeStyle
            },
            rangeClasses() {
                return (this.outOfFiveField ? 'out-of-five ' : '') + 'range-type-' + this.rangeType
            }
        }
    }
</script>

<style scoped>
    .field.condensed {
      padding: 0;
      margin: 0;
    }
    .range-selection-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .range-selection-container.out-of-five {
      justify-content: start;
    }
    .range-selection-wrapper.condensed {
      display: flex;
      align-items: center;
    }
    .range-selection-wrapper.condensed .question-top {
      width: 30%;
    }
    .range-selection-wrapper.condensed .field-selection-container {
      width: 70%;
    }
    .range-selection-wrapper.condensed .question-top .question-icon {
      display: none !important;
    }
    .range-selection-wrapper.condensed .range-selection-container .before-icon,
    .range-selection-wrapper.condensed .range-selection-container .after-icon {
      display: none;
    }

    .range-selection-container .before-icon {
        margin-right: 10px;
    }
    .range-selection-container .before-icon,
    .range-selection-container .after-icon {
        position: relative;
    }
    .range-selection-container .before-icon .field-tooltip,
    .range-selection-container .after-icon .field-tooltip {
        display: none;
    }
    .range-selection-container .before-icon:hover .field-tooltip,
    .range-selection-container .after-icon:hover .field-tooltip {
        display: block;
    }
    .range-selection-container .after-icon {
        margin-left: 10px;
    }
    .range-selection {
        width: 50px;
        height: 50px;
        border: solid 1px #e7e8eb;
        font-weight: bold;
        font-size: 15px;
        line-height: 50px;
        text-align: center;
        cursor: pointer;
    }
    .range-selection:hover {
        border-color: #00aef1;
    }
    .range-selection.selected .option {
        color: #fff;
        background: #00aef1;
        animation: brightness-flash 0.3s;
    }
    .icon-option{
      max-width: 30px;
    }
    .icon-option-container {
      display: flex;
      flex-direction: column;
      justify-content: center;  /* Centering y-axis */
      align-items :center; /* Centering x-axis */
      height: 100%;
    }
</style>
